
import { mdiDelete } from '@mdi/js';
export default {
  props: {
    action: {
      type: String,
      default: 'delete this item',
    },
  },
  data: () => ({ dialog: false, mdiDelete }),
};
